import { IPolicy } from '../models';
import * as moment from 'moment-timezone';
import { getIncludedResource } from '../util';
import * as document from './documents';
import * as transaction from './transaction';

const dateFromApi = (date) => {
  if (! date) {
    return '';
  }

  const parsedDate = moment(date).tz('UTC').format('DD/MM/YYYY');

  return parsedDate !== 'Invalid Date' ? parsedDate : '';
};

export function fromJsonApi(data, included: any[]): IPolicy {
  const documents = getIncludedResource(data, included, 'documents', true)
    .map((item) => document.fromJsonApi(item, included));

  const transactionSet = getIncludedResource(data, included, 'policy_applications', true)
    .map((item) => getIncludedResource(item, included, 'transactions', true))[0];
  const transactions = transactionSet ? transactionSet.map((item2) => transaction.fromJsonApi(item2)) : [];

  const supersededPolicy = getIncludedResource(data, included, 'superseded_policy');

  /*
   */
  return {
    policyNumber: data.attributes.policy_number,
    id: data.id,
    insured: data.attributes.insured,
    status: data.attributes.status,
    version: data.attributes.version,
    productName: data.attributes.product_name,
    userName: data.attributes.user_name,
    brokerName: data.attributes.broker_name,
    channelName: data.attributes.channel_name,
    minimumDocumentCount: data.attributes.minimum_document_count,
    isInsideCancellationPeriod: data.attributes.is_inside_cancellation_period,
    metadata: data.attributes.metadata,
    commencesAt: dateFromApi(data.attributes.commences_at),
    expiresAt: dateFromApi(data.attributes.expires_at),
    issuedAt: dateFromApi(data.attributes.issued_at),
    cancelledAt: dateFromApi(data.attributes.cancelled_at),
    totalPremiumValue: data.attributes.total_premium_value,
    documents,
    transactions,
    supersededPolicy,
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/data/api/transformers/policy.ts